import { FC } from "react"
import { css } from "@emotion/react"
import { CustomerBrandCard } from "@ncs/ncs-api"
import { Link, EventTracker, Card, useScreenSizeMatch } from "@ncs/web-legos"
import { useAnalytics } from "~/hooks/useAnalytics"

interface ShopBrandCtaProps {
	card: CustomerBrandCard
}

export const ShopBrandCtaEcomm: FC<ShopBrandCtaProps> = ({ card }) => {
	const isExternalLink = card.buttonDestinationUrl.startsWith("http")
	const eventName = `BC_${card.name
		.replace(" - New Home Page", "")
		.trim()
		.split(" ")
		.join("_")
		.toUpperCase()}`
	const { trackEvent } = useAnalytics()
	const screenIsMediumUp = useScreenSizeMatch("md", "up")

	return (
		<Card
			variant="plain"
			maxHeight={screenIsMediumUp ? 15.625 : 7}
			minHeight={screenIsMediumUp ? 8.375 : 7}
			textAlign="center"
			css={cardStyle}
		>
			<EventTracker event={eventName} trackEvent={trackEvent}>
				<Link
					to={card.buttonDestinationUrl}
					newTab={card.buttonDestinationOpensNewWindow}
					external={isExternalLink}
				>
					<img
						id={`brand-card-${card.name}`}
						src={card.logoImageUrl}
						alt={`Logo for ${card.name}`}
						width={184}
						height={53}
						loading="lazy"
					/>
					<span css={taglineTextCss}>{card.taglineText}</span>
				</Link>
			</EventTracker>
		</Card>
	)
}

const cardStyle = css`
	text-align: center;
	padding: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	img {
		display: inline-block;
	}
`

const taglineTextCss = css`
	display: block;
	font-size: 0.875rem;
	color: #1f2937;
`
